import React, { useState, useEffect } from 'react';
import { API_CONFIG } from '../../../utils/config';
import './hairtreatmentlanding.css';
import logo from '../../../assets/images/hcura-homeopathy-logo.png'; // Add your logo file to src/assets/
import landing from '../../../assets/images/banner/landing-page.jpg'; // Add your landing image file to src/assets/
import { Link } from 'react-router-dom'; // Import Link

import BookConsultation from '../../screens/BookConsultation/bookconsultation';
// Add these imports at the top of your file
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";

const HairTreatmentLanding = () => {
   const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    treatment: '',
    location: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers
      const numericValue = value.replace(/\D/g, '');
      
      // Limit to 10 digits
      const limitedValue = numericValue.slice(0, 10);
      
      setFormData({
        ...formData,
        [name]: limitedValue
      });

      // Validate phone number
      if (limitedValue.length > 0 && limitedValue.length < 10) {
        setPhoneError('Phone number must be exactly 10 digits');
      } else {
        setPhoneError('');
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Final validation for phone number
    if (formData.phone.length !== 10) {
      setPhoneError('Phone number must be exactly 10 digits');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        `${API_CONFIG.baseURL7001}${API_CONFIG.apiPath}${API_CONFIG.apiName.apptFormFilling}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.fullName,          // Maps fullName to name
            phoneNo: formData.phone,          // Maps phone to phoneno
            emailid: formData.email,          // Maps email to emailid
            consultationType: formData.treatment, // Maps treatment to consultationType
            branch: formData.location,        // Maps location to branch
            message: formData.message         // Maps message to message
          })
        }
      );

      if (response.ok) {
        setIsSuccess(true);
        setFormData({
          fullName: '',
          phone: '',
          email: '',
          treatment: '',
          location: '',
          message: ''
        });
        setPhoneError('');
        
        setTimeout(() => {
          setIsSuccess(false);
        }, 5000);
      } else {
        console.error('Form submission failed with status:', response.status);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <section className="lp-digital-consultation-section">
        <div className="lp-digital-consultation-container">
          <div className="lp-digital-success-container">
            <div className="lp-digital-success-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            <h2 className="lp-digital-success-title">Appointment Booked Successfully!</h2>
            <p className="lp-digital-success-message">
              Thank you for choosing H-Cura! Your consultation request has been received.
            </p>
            <div className="lp-digital-success-details">
              <div className="lp-digital-success-card">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                <div>
                  <h4>What's Next?</h4>
                  <p>Our team will contact you within 24 hours to confirm your appointment</p>
                </div>
              </div>
              <div className="lp-digital-success-card">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <div>
                  <h4>Need Immediate Help?</h4>
                  <p>Call us at <a href="tel:08870001377">088700 01377</a></p>
                </div>
              </div>
            </div>
            <button 
              onClick={() => setIsSuccess(false)} 
              className="lp-digital-success-button"
            >
              Book Another Appointment
            </button>
          </div>
        </div>
      </section>
    );
  }

  
const treatments = [
    {
      id: 1,
      name: 'GFC Hair Therapy',
      url: '/advanced-hair-gfc-treatment',
      description: 'Growth Factor Concentrate therapy stimulates natural hair growth using your body\'s own healing factors.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      benefits: ['Natural hair regrowth', 'Minimal downtime', 'Long-lasting results']
    },
    {
      id: 2,
      name: 'Advanced GFC',
      url: '/advanced-hair-gfc-treatment',
      description: 'Enhanced GFC treatment with advanced concentration techniques for maximum hair restoration results.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      ),
      benefits: ['Superior concentration', 'Faster results', 'Enhanced efficacy']
    },
    {
      id: 3,
      name: 'PRP Hair Treatment',
      url: '/advanced-hair-prp-treatment',
      description: 'Platelet-Rich Plasma therapy uses your blood\'s healing properties to rejuvenate hair follicles.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      ),
      benefits: ['Proven technology', 'Safe & natural', 'Visible improvement']
    },
    {
      id: 4,
      name: 'Advanced PRP',
      url: '/advanced-hair-prp-treatment',
      description: 'Next-generation PRP with enhanced platelet concentration for superior hair restoration outcomes.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
          <polyline points="7.5 4.21 12 6.81 16.5 4.21"/>
          <polyline points="7.5 19.79 7.5 14.6 3 12"/>
          <polyline points="21 12 16.5 14.6 16.5 19.79"/>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
          <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
      ),
      benefits: ['Maximum potency', 'Advanced processing', 'Optimal results']
    },
    {
      id: 5,
      name: 'STM Treatment',
      url: '/advanced-stm-treatment',
      description: 'Stem Cell Therapy for hair regeneration using cutting-edge regenerative medicine techniques.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
      ),
      benefits: ['Regenerative therapy', 'Advanced science', 'Long-term solution']
    },
    {
      id: 6,
      name: 'Gro Hair',
      url: '/hair-treatment',
      description: 'Comprehensive hair growth solution combining multiple therapies for complete hair restoration.',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      benefits: ['Complete solution', 'Customized approach', 'Proven results']
    },
 
  ];


  const transformationImages = [
  { id: 1, label: 'Hair Transformation 1', image: img1 },
  { id: 2, label: 'Hair Transformation 2', image: img2 },
  { id: 3, label: 'Hair Transformation 3', image: img3 },
  { id: 4, label: 'Hair Transformation 4', image: img4 },
  { id: 5, label: 'Hair Transformation 5', image: img5 },
    { id: 3, label: 'Hair Transformation 3', image: img3 },

  { id: 6, label: 'Hair Transformation 6', image: img6 },
  { id: 7, label: 'Hair Transformation 7', image: img7 },
  { id: 8, label: 'Hair Transformation 8', image: img8 },
  { id: 9, label: 'Hair Transformation 9', image: img9 },
  { id: 10, label: 'Hair Transformation 10', image: img10 }
];

  const locations = [
    {
      city: 'Chennai',
      branches: ['Valasaravakkam', 'Gerugambakkam', 'Tambaram', 'Navalur', 'Vadapalani']
    },
    {
      city: 'Bangalore',
      branches: ['Jayanagar']
    },
    {
      city: 'Pondicherry',
      branches: ['Pondicherry']
    }
  ];

  const googleTestimonials = [
    {
    name: "Rahul Sharma",
      treatment: 'Advanced GFC',
      rating: 5,
    text: "H-Cura Clinic really transformed my hair with their PRP treatment. The doctors explained everything clearly, and I started seeing results in just a few sessions. The clinic was super clean and welcoming. Highly recommended for anyone facing hair loss issues. I felt very comfortable throughout the treatment journey and would definitely visit again for follow-ups.",
      image: 'RK',
      verified: true
    },
    {
      name: 'Priya Sharma',
      treatment: 'PRP Hair Treatment',
      rating: 5,
    text: "I had severe acne problems, but the skin specialists at H-Cura worked wonders. They suggested laser treatment combined with skincare routines. The results were better than I expected. I feel more confident and happy now! Their approach is professional yet very friendly. The team keeps checking up on me to make sure my skin is improving steadily.",
      image: 'PS',
      verified: true
    },
    {
    name: "Mohammed Iliyas",
      treatment: 'Laser Treatment',
      rating: 5,
    text: "I visited H-Cura for dental implants. The process was smooth, painless, and professional. The doctors are highly skilled and use modern technology. My smile looks natural again, and I can't thank them enough for the care and support I received throughout the journey. They gave me multiple treatment options and explained costs transparently.",
      image: 'AP',
      verified: true
    },
    {
      name: 'Sneha Reddy',
      treatment: 'STM Treatment',
      rating: 5,
    text: "I had been struggling with hair thinning for years. After consulting many clinics, I finally chose H-Cura. The PRP sessions were effective and painless. The staff is friendly, and the clinic ambiance is modern and relaxing. Within three months, I noticed a huge difference in my hair density and quality.",
      image: 'SR',
      verified: true
    },
    {
    name: "Vikram Kumar",
      treatment: 'Gro Hair',
      rating: 5,
    text: "I went for a dental cleaning and cavity filling. The doctors explained the whole process in simple words and made me feel at ease. The clinic uses advanced tools and hygiene is top-notch. My treatment was quick and smooth, and the results are excellent. Highly recommend H-Cura for dental care.",
      image: 'VS',
      date: '2 months ago',
      verified: true
    },
    // {
    //   name: 'Divya Menon',
    //   treatment: 'Advanced PRP',
    //   rating: 5,
    //   text: 'Outstanding treatment! My hair loss problem is completely resolved. The advanced PRP treatment gave me the confidence back. Thank you to the entire team at H-Cura for their support.',
    //   image: 'DM',
    //   date: '3 weeks ago',
    //   verified: true
    // }
  ];

  const scrollToBooking = () => {
    
    const bookingSection = document.getElementById('booking-section');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="lp-hair-landing">

       <section className="lp-digital-consultation-section">
      <div className="lp-digital-consultation-container">
        <div className="lp-digital-consultation-header">
          <h2 className="lp-digital-header-title">Book Your Free Consultation</h2>
          <p className="lp-digital-header-description">
Find the root cause of hair loss and start visible regrowth with H-Cura’s Treatment at just ₹999.          </p>
        </div>

        <div className="lp-digital-consultation-content">
          <div className="lp-digital-benefits-column">
            <div className="lp-digital-benefit-card">
              <div className="lp-digital-benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h3>Free Consultation</h3>
              <p></p>
            </div>

            <div className="lp-digital-benefit-card">
              <div className="lp-digital-benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <h3>Quick Response</h3>
              <p>We'll contact you within 24 hours</p>
            </div>

            <div className="lp-digital-benefit-card">
              <div className="lp-digital-benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>Expert Doctors</h3>
              <p></p>
            </div>

            <div className="lp-digital-contact-info">
              <p className="lp-digital-contact-label">Or reach us directly:</p>
              <a href="tel:08870001377" className="lp-digital-contact-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                +91 99646 88333
              </a>
              <a href="mailto:info@hcura.com" className="lp-digital-contact-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                admin@h-cura.com
              </a>
            </div>
          </div>

          <div className="lp-digital-form-column">
            <form onSubmit={handleSubmit} className="lp-digital-consultation-form">
              <div className="lp-digital-form-row">
                <div className="lp-digital-form-group">
                  <label htmlFor="fullName">Full Name <span className="lp-digital-required">*</span></label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="Enter your full name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className={`lp-digital-form-group ${phoneError ? 'lp-digital-error' : ''}`}>
                  <label htmlFor="phone">Phone Number <span className="lp-digital-required">*</span></label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="10 digit number"
                    value={formData.phone}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    maxLength="10"
                    inputMode="numeric"
                    required
                  />
                  {phoneError && (
                    <span className="lp-digital-error-message">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="12"/>
                        <line x1="12" y1="16" x2="12.01" y2="16"/>
                      </svg>
                      {phoneError}
                    </span>
                  )}
                </div>
              </div>

              <div className="lp-digital-form-row">
                <div className="lp-digital-form-group">
                  <label htmlFor="treatment">Treatment <span className="lp-digital-required">*</span></label>
                  <select
                    id="treatment"
                    name="treatment"
                    value={formData.treatment}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a treatment</option>
                    <option value="gfc">GFC</option>
                    <option value="advanced-gfc">Advanced GFC</option>
                    <option value="prp">PRP</option>
                    <option value="advanced-prp">Advanced PRP</option>
                    <option value="stm">STM</option>
                    <option value="gro-hair">Gro Hair</option>
                    <option value="laser-treatment">Laser Treatment</option>
                  </select>
                </div>

                <div className="lp-digital-form-group">
                  <label htmlFor="location">Preferred Location <span className="lp-digital-required">*</span></label>
                  <select
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a location</option>
                    <optgroup label="Chennai">
                      <option value="chennai-valasaravakkam">Valasaravakkam</option>
                      <option value="chennai-gerugambakkam">Gerugambakkam</option>
                      <option value="chennai-tambaram">Tambaram</option>
                      <option value="chennai-navalur">Navalur</option>
                      <option value="chennai-vadapalani">Vadapalani</option>
                    </optgroup>
                    <optgroup label="Bangalore">
                      <option value="bangalore-jayanagar">Jayanagar</option>
                    </optgroup>
                    <optgroup label="Pondicherry">
                      <option value="pondicherry">Pondicherry</option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div className="lp-digital-form-group">
                <label htmlFor="email">Email Address <span className="lp-digital-optional">(Optional)</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="lp-digital-form-group">
                <label htmlFor="message">Additional Message <span className="lp-digital-optional">(Optional)</span></label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Do you have a preferred date and time for your appointment ?..."
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                />
                              </div>

              <button 
                type="submit" 
                className="lp-digital-submit-button"
                disabled={isSubmitting || phoneError || formData.phone.length !== 10}
              >
                {isSubmitting ? (
                  <>
                    <span className="lp-digital-spinner"></span>
                    Booking...
                  </>
                ) : (
                  <>
                    Book Appointment
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="5" y1="12" x2="19" y2="12"/>
                      <polyline points="12 5 19 12 12 19"/>
                    </svg>
                  </>
                )}
              </button>

              <p className="lp-digital-privacy-notice">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                We respect your privacy. Your information is secure and will never be shared.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
      {/* Hero Section */}
      <section className="lp-hair-hero">
        <div className="lp-hair-hero-container">
          <div className="lp-hair-hero-content">
            <div className="lp-hair-hero-badge">H-Cura Multispecialty Clinic</div>
            <h1 className="lp-hair-hero-title">
              Restore Your Hair,<br />
              <span className="lp-hair-gradient-text">Restore Your Confidence</span>
            </h1>
            <p className="lp-hair-hero-description">
              Advanced hair restoration treatments with proven results. Experience the latest in hair regrowth technology at H-Cura's state-of-the-art facilities.
            </p>
            <div className="lp-hair-hero-stats">
              <div className="lp-hair-stat">
                <div className="lp-hair-stat-number">15,000+</div>
                <div className="lp-hair-stat-label">Happy Patients</div>
              </div>
              <div className="lp-hair-stat">
                <div className="lp-hair-stat-number">96%</div>
                <div className="lp-hair-stat-label">Success Rate</div>
              </div>
              <div className="lp-hair-stat">
                <div className="lp-hair-stat-number">7+</div>
                <div className="lp-hair-stat-label">Locations</div>
              </div>
            </div>
            <div className="lp-hair-hero-cta">
              <button onClick={scrollToBooking} className="lp-hair-btn-primary">
              <Link to='/bookconsultation'>Book Consultation</Link>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
              <a href="tel:9964688333" className="lp-hair-btn-secondary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Call Now
              </a>
            </div>
          </div>
          <div className="lp-hair-hero-image">
            <div className="lp-hair-hero-image-placeholder">
              <img src={landing} alt="Hair Restoration" className="lp-hair-hero-img" />
            </div>
          </div>
        </div>
      </section>


      {/* Transformation Scrolling Section - Single Cards */}
      {/* Transformation Scrolling Section - With Real Images */}
<section className="lp-hair-transformations">
  <div className="lp-hair-section-header">
    <h2 className="lp-hair-section-title">Real Results from Real Patients</h2>
    <p className="lp-hair-section-description">
      See the amazing transformations our patients have achieved
    </p>
  </div>
  <div className="lp-hair-scroll-container">
    <div className="lp-hair-scroll-track">
      {[...transformationImages, ...transformationImages].map((item, index) => (
        <div key={index} className="lp-hair-transformation-card">
          <div className="lp-hair-image-wrapper">
            <img 
              src={item.image} 
              alt={item.label}
              className="lp-hair-transformation-img"
              loading="lazy"
            />
            <div className="lp-hair-image-overlay"></div>
          </div>
          <div className="lp-hair-transformation-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            Verified Result
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Treatments Section */}
      <section className="lp-hair-treatments">
        <div className="lp-hair-container">
          <div className="lp-hair-section-header">
            <h2 className="lp-hair-section-title">Our Hair Restoration Treatments</h2>
            <p className="lp-hair-section-description">
              Choose from our range of advanced, scientifically-proven hair restoration treatments tailored to your needs
            </p>
          </div>
          <div className="lp-hair-treatments-grid">
            {treatments.map((treatment) => (
              <Link to={treatment.url} key={treatment.id} className="lp-hair-treatment-card-link"> {/* Added Link component */}
                <div className="lp-hair-treatment-card">
                  <div className="lp-hair-treatment-icon">{treatment.icon}</div>
                  <h3 className="lp-hair-treatment-name">{treatment.name}</h3>
                  <p className="lp-hair-treatment-description">{treatment.description}</p>
                  <ul className="lp-hair-treatment-benefits">
                    {treatment.benefits.map((benefit, index) => (
                      <li key={index}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                  <button onClick={scrollToBooking} className="lp-hair-treatment-btn">
                    Read More
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="lp-hair-why-choose">
        <div className="lp-hair-container">
          <div className="lp-hair-section-header">
            <h2 className="lp-hair-section-title">Why Choose H-Cura?</h2>
            <p className="lp-hair-section-description">
              Experience the difference with India's leading hair restoration specialists
            </p>
          </div>
          <div className="lp-hair-features-grid">
        
            <div className="lp-hair-feature">
              <div className="lp-hair-feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                  <line x1="7" y1="7" x2="7.01" y2="7"/>
                </svg>
              </div>
              <h3>Affordable Pricing</h3>
              <p>Competitive pricing with flexible payment options and EMI facilities</p>
            </div>
            <div className="lp-hair-feature">
              <div className="lp-hair-feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
              </div>
              <h3>Multiple Locations</h3>
              <p>7+ clinics across Chennai, Bangalore, and Pondicherry for your convenience</p>
            </div>
            <div className="lp-hair-feature">
              <div className="lp-hair-feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>Personalized Care</h3>
              <p>Customized treatment plans designed specifically for your hair type and condition</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google Testimonials Scrolling Section */}
      <section className="lp-hair-testimonials">
        <div className="lp-hair-container">
          <div className="lp-hair-section-header">
            <div className="lp-hair-google-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <span>Google Reviews</span>
            </div>
            <h2 className="lp-hair-section-title">What Our Patients Say</h2>
            <p className="lp-hair-section-description">
              Real stories from real people who transformed their lives with H-Cura
            </p>
          </div>
        </div>
        <div className="lp-hair-testimonials-scroll-container">
          <div className="lp-hair-testimonials-scroll-track">
            {[...googleTestimonials, ...googleTestimonials, ...googleTestimonials].map((testimonial, index) => (
              <div key={index} className="lp-hair-google-testimonial-card">
                <div className="lp-hair-testimonial-header">
                  <div className="lp-hair-testimonial-avatar">{testimonial.image}</div>
                  <div className="lp-hair-testimonial-info">
                    <div className="lp-hair-testimonial-name-row">
                      <span className="lp-hair-testimonial-name">{testimonial.name}</span>
                      {testimonial.verified && (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#10b981">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      )}
                    </div>
                    <div className="lp-hair-testimonial-date">{testimonial.date}</div>
                  </div>
                </div>
                <div className="lp-hair-testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#fbbf24">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  ))}
                </div>
                <p className="lp-hair-testimonial-text">{testimonial.text}</p>
                <div className="lp-hair-testimonial-treatment-tag">
                  {testimonial.treatment}
                </div>
                <div className="lp-hair-google-logo">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="lp-hair-locations">
        <div className="lp-hair-container">
          <div className="lp-hair-section-header">
            <h2 className="lp-hair-section-title">Our Locations</h2>
            <p className="lp-hair-section-description">
              Visit us at any of our conveniently located clinics
            </p>
          </div>
          <div className="lp-hair-locations-grid">
            {locations.map((location, index) => (
              <div key={index} className="lp-hair-location-card">
                <div className="lp-hair-location-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <h3 className="lp-hair-location-city">{location.city}</h3>
                <ul className="lp-hair-location-branches">
                  {location.branches.map((branch, idx) => (
                    <li key={idx}>{branch}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

{/* Process Section - Perfect Number Visibility */}
{/* How It Works Section - New Design */}
<section className="hcura-journey-section">
  <div className="hcura-journey-container">
    <div className="hcura-journey-header">
      <h2 className="hcura-journey-title">How It Works</h2>
      <p className="hcura-journey-subtitle">
        Your journey to hair restoration in 4 simple steps
      </p>
    </div>

    <div className="hcura-steps-wrapper">
      <div className="hcura-steps-grid">
        {/* Step 1 */}
        <div className="hcura-step-item">
          <div className="hcura-step-badge">
            <span className="hcura-step-count">01</span>
          </div>
          <div className="hcura-step-content">
            <div className="hcura-step-icon-box">
              <svg className="hcura-step-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
              </svg>
            </div>
            <h3 className="hcura-step-heading">Book Consultation</h3>
            <p className="hcura-step-text">
              Schedule your free consultation with our hair  experts
            </p>
          </div>
        </div>

        {/* Connector Line */}
        <div className="hcura-step-connector">
          <div className="hcura-connector-line"></div>
          <div className="hcura-connector-dot"></div>
        </div>

        {/* Step 2 */}
        <div className="hcura-step-item">
          <div className="hcura-step-badge">
            <span className="hcura-step-count">02</span>
          </div>
          <div className="hcura-step-content">
            <div className="hcura-step-icon-box">
              <svg className="hcura-step-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
            <h3 className="hcura-step-heading">Hair Analysis</h3>
            <p className="hcura-step-text">
              Comprehensive scalp and hair analysis to determine the best treatment
            </p>
          </div>
        </div>

        {/* Connector Line */}
        <div className="hcura-step-connector">
          <div className="hcura-connector-line"></div>
          <div className="hcura-connector-dot"></div>
        </div>

        {/* Step 3 */}
        <div className="hcura-step-item">
          <div className="hcura-step-badge">
            <span className="hcura-step-count">03</span>
          </div>
          <div className="hcura-step-content">
            <div className="hcura-step-icon-box">
              <svg className="hcura-step-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            <h3 className="hcura-step-heading">Treatment Plan</h3>
            <p className="hcura-step-text">
              Personalized treatment plan tailored to your specific needs and goals
            </p>
          </div>
        </div>

        {/* Connector Line */}
        <div className="hcura-step-connector">
          <div className="hcura-connector-line"></div>
          <div className="hcura-connector-dot"></div>
        </div>

        {/* Step 4 */}
        <div className="hcura-step-item">
          <div className="hcura-step-badge">
            <span className="hcura-step-count">04</span>
          </div>
          <div className="hcura-step-content">
            <div className="hcura-step-icon-box">
              <svg className="hcura-step-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
              </svg>
            </div>
            <h3 className="hcura-step-heading">See Results</h3>
            <p className="hcura-step-text">
              Watch your hair transform with visible results in just a few months
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
  );
};

export default HairTreatmentLanding;
